import { Component, OnInit } from '@angular/core';
import { AccountServiceProxy, LoginQuery, SignUpCommand, LogoutQuery } from '../service-proxies';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  title = 'mashwrah';
  constructor() { }

  ngOnInit() {
  }
  slides = [
    {img: "../../assets/img/IconsGreen/Education.png",name:"Education"},
    {img: "../../assets/img/IconsGreen/Career.png",name:"Career"},
    {img: "../../assets/img/IconsGreen/Culture.png",name:"Cultural Issues"},
    {img: "../../assets/img/IconsGreen/Religious.png",name:"Religion"},
    {img: "../../assets/img/IconsGreen/maintenanc.png",name:"Maintenance"},
  ];

  slideConfig = {
    "slidesToShow": 4,
    "slidesToScroll": 1,
    "nextArrow": "<div class='slick-dots'></div>",
    "prevArrow": "<div class='slick-dots'></div>",
    "dots": true,
    "infinite": true,
    "autoplay": true,
    "draggable": true,
    "autoplaySpeed": 3000,
  };

  // addSlide() {
  //   this.slides.push({img: "http://placehold.it/350x150/777777"})
  // }

  // removeSlide() {
  //   this.slides.length = this.slides.length - 1;
  // }

  slickInit(e) {
    console.log('slick initialized');
  }

  breakpoint(e) {
    console.log('breakpoint');
  }

  afterChange(e) {
    console.log('afterChange');
  }

  beforeChange(e) {
    console.log('beforeChange');
  }

}
